import { type FC } from 'react'

import { List } from '@dhl-ui/components'

import { type Servicepoint } from './model.js'
import { ServicepointListItem } from './ServicepointListItem.js'

type Props = {
  'data-testid'?: string
  servicepoints: Servicepoint[]
  onClick?: (servicepoint: Servicepoint) => void
  onSelect?: (servicepoint: Servicepoint) => void
  showOpeningTimes?: boolean
  isDesktop?: boolean
  useDialogSelect?: boolean
}

export const ServicepointList: FC<Props> = ({
  'data-testid': dataTestId,
  isDesktop = false,
  servicepoints,
  showOpeningTimes = true,
  useDialogSelect = false,
  onClick,
  onSelect,
}) => (
  <List data-testid={dataTestId}>
    {servicepoints.map((servicepoint, index) => (
      <ServicepointListItem
        defaultExpanded={isDesktop && index === 0}
        key={servicepoint.servicepointKey}
        servicepoint={servicepoint}
        divider={servicepoints.length > index + 1}
        onClick={onClick}
        onSelect={onSelect}
        showOpeningTimes={showOpeningTimes}
        isDesktop={isDesktop}
        useDialogSelect={useDialogSelect}
      />
    ))}
  </List>
)
